// extracted by mini-css-extract-plugin
module.exports = {"container":"JoinButton__container--rfB","join":"JoinButton__join--1ar"};